import { render, staticRenderFns } from "./disChart.vue?vue&type=template&id=2ecdfeb9&scoped=true"
import script from "./disChart.vue?vue&type=script&lang=js"
export * from "./disChart.vue?vue&type=script&lang=js"
import style0 from "./disChart.vue?vue&type=style&index=0&id=2ecdfeb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecdfeb9",
  null
  
)

export default component.exports